import React from "react";
import { defineMessages } from "react-intl";
import MessageDialog from "./MessageDialog";
import Button from "../../button/Button";

const messages = defineMessages({
  yes: {
    id: "yes",
    defaultMessage: "Yes"
  },

  no: {
    id: "no",
    defaultMessage: "No"
  }
});

/**
 * Confirmation dialog that displays a message to the user with the option to say Yes or No.
 * 
 * Props:
 * - onConfirm: Function called when the user taps the onConfirm button, developer must set the isVisible prop to false to dismiss the dialog.
 * - onCancel: Function called when the user taps the onConfirm button, developer must set the isVisible prop to false to dismiss the dialog.
 * See MessageDialog, for additional props.
 */
const Confirm = ({ onConfirm, onCancel, ...restProps }) => (
  <MessageDialog {...restProps}>
    {/* Yes button */}
    <Button title={messages.yes} margins="0 10px 0 0" onPress={onConfirm} />

    {/* No button */}
    <Button title={messages.no} ui="secondary" onPress={onCancel} />
  </MessageDialog>
);

Confirm.defaultProps = {
  onConfirm: () => {},
  onCancel: () => {}
};

export default Confirm;
